import { withTranslation } from "react-i18next";
import withAuthentication from "./withAuthentication";
import withNotification from "./withNotification";

export default Component =>
  withTranslation()(withNotification(withAuthentication(Component)));
